export { default as CorePermissionSimpleService } from './simple';
export { default as CorePermissionsService } from './standard';
